import http from '@/utils/http'

const create = ({ user_id, minutes, card_id, reason }) => http()
  .post(`/minute_gifts`, {
    user_id,
    minutes,
    reason,
    card_id
  })

const update = ({ id }) => http()
  .put(`/minute_gifts/${id}`)

export default {
  create,
  update
}



// WEBPACK FOOTER //
// ./src/api/minute_gift.js